jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{variant.id}}"
     */
	   $( document ).on( "variant:changed", function( evt ) {         
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   });

});

document.addEventListener("DOMContentLoaded", (event) => {
	if(document.querySelectorAll('[data-check-product-zipcode]')){
		document.querySelectorAll('[data-check-product-zipcode]').forEach( item => {
			if(!isExactCodeInList(cookieValue, item.dataset.checkProductZipcode)){
				item.closest('section').remove();
			}
		});
		function isExactCodeInList(code, list) {
			const regex = new RegExp(`(^|,)${code}($|,)`);
			return regex.test(list);
		}
	}
});

